import { LitElement, html, svg } from 'lit';

export class IconExpand24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>To diagonale piler pekende i hver sin retning</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 14.999 1.5 22.5M16 1h6.75v6.719M7.75 22.75H1v-6.727M22.5 1.5 15 8.999"></path></svg>`; }
}
if (!customElements.get('f-icon-expand24', IconExpand24)) {
  customElements.define('f-icon-expand24', IconExpand24);
}